<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Read Aloud</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content">
  <h2>Customized useCase options for Read-aloud</h2>
  <div class="content__tools-wrap">
    <div class="content__row">
      <label for="useCase" class="content__row-label">Use Cases</label>
      <select [(ngModel)]="selectedUseCase" class="c-input-group__control" id="useCase">
        <ng-container *ngFor="let useCase of useCases">
          <option [value]="useCase">{{ useCase }}</option>
        </ng-container>
      </select>
    </div>        
  </div>
</div>
<audio id="audio" src="https://www.learningcontainer.com/wp-content/uploads/2020/02/Kalimba.mp3"></audio>

<div class="content content--modifier" *ngIf="selectedUseCase === 'Read-Aloud with boundrary'">
  <maced-draggable id="drag1" draggableBoundary="content" ariaLabel="drag and drop" [toolTipData]="draggableToolTipData" [hasCloseButtonInside] = "true" buttonId="Close" closeButtonAriaLabel = "close" (closeEvent)="closeEvent()">
    <maced-read-aloud id="player1" [isReadAloudBack]="true" [toolTipData]="toolTipData" [isReadAloudForward]="true" [hasRefreshOption]="true" [playDisable]="false" [labels]="displayLabels" [forwardDisabled]="forwardDisabled" [backwardDisabled]="backwardDisabled"
      (PlayPauseEvent)="playPause($event)" (PlayerReload)="playerReload()"  (PlayerForward)="forwardPlay()" (PlayerBackward)="backwardPlay()">
    </maced-read-aloud>
  </maced-draggable>
</div><br><br><br>

<div class="content" *ngIf="selectedUseCase === 'Read-Aloud without boundrary'">
  <maced-draggable id="drag2" ariaLabel="drag and drop" [showCloseIcon]="true" buttonId="Close1" closeButtonAriaLabel = "close">
    <maced-read-aloud id="player2" [isReadAloud]="false" [playDisable]="true" [labels]="displayLabels"
      (PlayPauseEvent)="playPause($event)" (PlayerReload)="playerReload()">
    </maced-read-aloud>
  </maced-draggable> 
</div>

<div class="content" *ngIf="selectedUseCase === 'Read-Aloud with right side draggable button'">
  <maced-draggable id="drag3" ariaLabel="drag and drop" buttonId="Close3" [hasCloseButtonInside]="true" closeButtonAriaLabel = "close"
  [hasDragButtonLeft] = "false" [hasDragButtonRight] = "true"  [toolTipData]="draggableMobileToolTipData" >
    <maced-read-aloud id="player3" [isReadAloud]="false" [playDisable]="true" [labels]="displayLabels"
      (PlayPauseEvent)="playPause($event)" (PlayerReload)="playerReload()">
    </maced-read-aloud>
  </maced-draggable> 
</div>